import { getQuantity, getQuantityValidation } from '../bom/selectors';

import { NumericValueOfNotAvailable } from '../utils/constants';
import { SpecialChargeConditionNumber } from './constants';
import { createSelector } from 'reselect';
import { getVendor } from '../main/selectors';

const calculateSpecialCharge = (allowPrice, quantityValidation, quantity, charges, additionalChargeCount) => {
  if (!allowPrice || !quantityValidation.isValid || charges.length === 0) {
    return { hasCharge: false, isNotAvailable: false, chargeAmount: undefined };
  } else if (charges.some((charge) => charge.isNotAvailable)) {
    return { hasCharge: true, isNotAvailable: true, chargeAmount: NumericValueOfNotAvailable };
  } else {
    const chargeAmount = charges.reduce((total, charge) => {
      let qty = charge.chargePerCode.toUpperCase() === 'L' ? 1 : quantity;
      let tmpAmount = qty * charge.chargeAmount;
      if (additionalChargeCount !== undefined) tmpAmount *= additionalChargeCount;
      return total + tmpAmount;
    }, 0);
    return {
      hasCharge: true,
      isNotAvailable: false,
      chargeAmount,
    };
  }
};

export const getAdditionalColorCharge = createSelector(
  getVendor,
  getQuantityValidation,
  getQuantity,
  (state) => state.charges,
  (vendor, validation, quantity, charges) => {
    return calculateSpecialCharge(
      vendor.allowPrice,
      validation,
      quantity,
      charges.filter(
        (charge) =>
          charge.chargeConditionNumber === SpecialChargeConditionNumber.AdditionalColorRunCharge ||
          charge.chargeConditionNumber === SpecialChargeConditionNumber.AdditionalColorSetUpCharge
      )
    );
  }
);

export const getAdditionalImprintCharge = createSelector(
  getVendor,
  getQuantityValidation,
  getQuantity,
  (state) => state.charges,
  (_, imprintLocationCount) => imprintLocationCount,
  (vendor, validation, quantity, charges, imprintLocationCount) => {
    return calculateSpecialCharge(
      vendor.allowPrice,
      validation,
      quantity,
      charges.filter(
        (charge) =>
          charge.chargeConditionNumber === SpecialChargeConditionNumber.AdditionalImprintSetUpCharge ||
          charge.chargeConditionNumber === SpecialChargeConditionNumber.AdditionalImprintRunCharge
      ),
      imprintLocationCount > 1 ? imprintLocationCount - 1 : 0
    );
  }
);

export const getInsideCoverCharge = createSelector(
  getVendor,
  getQuantityValidation,
  getQuantity,
  (state) => state.charges,
  (vendor, validation, quantity, charges) => {
    return calculateSpecialCharge(
      vendor.allowPrice,
      validation,
      quantity,
      charges.filter((charge) => charge.chargeConditionNumber === SpecialChargeConditionNumber.CustomizeYourInsideCover)
    );
  }
);

export const getLogoEnhancementCharge = createSelector(
  getVendor,
  getQuantityValidation,
  getQuantity,
  (state) => state.charges,
  (vendor, validation, quantity, charges) => {
    return calculateSpecialCharge(
      vendor.allowPrice,
      validation,
      quantity,
      charges.filter((charge) => charge.chargeConditionNumber === SpecialChargeConditionNumber.LogoEnhancement)
    );
  }
);

export const getPmsColorCharge = createSelector(
  getVendor,
  getQuantityValidation,
  getQuantity,
  (state) => state.charges,
  (vendor, validation, quantity, charges) => {
    return calculateSpecialCharge(
      vendor.allowPrice,
      validation,
      quantity,
      charges.filter((charge) => charge.chargeConditionNumber === SpecialChargeConditionNumber.PmsColorCharge)
    );
  }
);

export const getPmsUnitPrice = (state) => {
  const charges = state.charges;

  const pmsCharge = charges.find(
    (charge) => charge.chargeConditionNumber === SpecialChargeConditionNumber.PmsColorCharge
  );

  return pmsCharge?.costChargeAmount;
};
